var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Button, Col, Datepicker, Row, Select, } from "@folio/stripes/components";
import { Controller, } from "react-hook-form";
import { useIntl } from "react-intl";
import moment from "moment";
import { RecekTextField } from "../inputs";
import { usePublisherGeneral } from "../../hooks/usePublisherGeneral";
import { PublisherLegalFormEnum } from "../../types/Api";
import styles from "./PublisherGeneral.module.css";
export var PublisherGeneral = function (_a) {
    var control = _a.control, errors = _a.errors, icoError = _a.icoError, setValue = _a.setValue, watch = _a.watch, icoLoadedCallback = _a.icoLoadedCallback, setIcoError = _a.setIcoError, trigger = _a.trigger;
    var formatMessage = useIntl().formatMessage;
    var _b = usePublisherGeneral(setValue, watch, icoLoadedCallback, setIcoError), legalFormValue = _b.legalFormValue, handleIco = _b.handleIco, isIcoFetching = _b.isIcoFetching;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({ labelId: legalFormValue === PublisherLegalFormEnum.LEGAL
                                ? "ui-br-legaldeposits.publishers.field.name.legal"
                                : "ui-br-legaldeposits.publishers.field.name.natural" }, field, { autoComplete: "off", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-legaldeposits.publishers.field.nameSuffix" }, field, { autoComplete: "off" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement("div", { className: styles.icoWrapper },
                            React.createElement(RecekTextField, __assign({ labelId: "ui-br-legaldeposits.publishers.field.companyNumber" }, field, { autoComplete: "off", onBlur: function () {
                                    field.onBlur();
                                    trigger(["companyNumber", "taxNumber", "birthDate"]);
                                }, error: (_c = (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : icoError, onChange: function (e) {
                                    field.onChange(e);
                                    setIcoError(null);
                                } })),
                            React.createElement(Button, { onClick: handleIco, disabled: isIcoFetching }, isIcoFetching
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.publishers.button.lookingUp",
                                })
                                : formatMessage({
                                    id: "ui-br-legaldeposits.publishers.button.lookupCompanyNumber",
                                }))));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { autoComplete: "off", label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.legalForm",
                            }), onChange: function (e) {
                                field.onChange(e);
                                trigger(["companyNumber", "taxNumber", "birthDate"]);
                            } }),
                            React.createElement("option", { value: PublisherLegalFormEnum.LEGAL }, formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.legalForm.legal",
                            })),
                            React.createElement("option", { value: PublisherLegalFormEnum.NATURAL }, formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.legalForm.natural",
                            }))));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-legaldeposits.publishers.field.taxNumber" }, field, { autoComplete: "off", error: (_b = errors.taxNumber) === null || _b === void 0 ? void 0 : _b.message, onBlur: function () {
                                field.onBlur();
                                trigger(["companyNumber", "taxNumber", "birthDate"]);
                            } })));
                    } })),
            legalFormValue === PublisherLegalFormEnum.NATURAL && (React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(Datepicker, __assign({}, field, { label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.birthDate",
                            }), autoComplete: "off", error: (_b = errors.birthDate) === null || _b === void 0 ? void 0 : _b.message, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", exclude: function (day) {
                                return day.isBefore(moment("1900-01-01", "YYYY-MM-DD")) ||
                                    day.isAfter(moment());
                            }, onBlur: function () {
                                field.onBlur();
                                trigger(["companyNumber", "taxNumber", "birthDate"]);
                            } })));
                    } }))))));
};
